import { GuestType, PublicEvent } from "@classview/shared-types";

export function isUserAttendingEvent(event: PublicEvent, userId: string) {
  return event.session.attendees?.some(
    (attendee) => attendee.type === GuestType.User && attendee.id === userId,
  );
}
